module.exports = __webpack_public_path__ + "img/select_like.6290b845.png";